import { useRef, useEffect } from 'react';
import { useCustomEvent } from '@wix/da-hooks/pkg/useCustomEvent';
import { scrollIntoViewInViewportBottom, scrollIntoViewInViewportCenter, } from '../../../utils/scrollIntoViewWithHeader';
import panelPopupStyles from './PanelPopup.scss';
var transitionDuration = parseFloat(panelPopupStyles['transitionDuration']) * 1000;
export function useCustomTransitionEvents(rootRef, isVisible, panelType) {
    var previousPanel = useRef(isVisible);
    var _a = useCustomEvent('open'), emitOpen = _a.emit, openEvent = _a.subscription;
    var _b = useCustomEvent('close'), emitClose = _b.emit, closeEvent = _b.subscription;
    var _c = useCustomEvent('openAnimation'), emitOpenAnimationDone = _c.emit, openAnimationEvent = _c.subscription;
    var _d = useCustomEvent('closeAnimation'), emitCloseAnimationDone = _d.emit, closeAnimationEvent = _d.subscription;
    useEffect(function () {
        var root = rootRef.current;
        var wasVisible = previousPanel.current;
        if (!root) {
            return;
        }
        var transitionTimeout;
        function onTransitionEnd() {
            if (transitionTimeout) {
                clearTimeout(transitionTimeout);
                transitionTimeout = undefined;
            }
            if (wasVisible && !isVisible) {
                emitCloseAnimationDone();
            }
            else if (isVisible && !wasVisible) {
                if (root) {
                    if (panelType === 'comment') {
                        scrollIntoViewInViewportCenter(root, false, undefined, true);
                    }
                    else {
                        scrollIntoViewInViewportBottom(root, false, 80, undefined, true);
                    }
                }
                emitOpenAnimationDone();
            }
        }
        if (wasVisible && !isVisible) {
            emitClose();
            // timeout in case the animation failed to play for whatever reason
            transitionTimeout = setTimeout(onTransitionEnd, transitionDuration);
        }
        else if (isVisible && !wasVisible) {
            emitOpen();
            if (panelType === 'comment') {
                onTransitionEnd();
            }
            else {
                transitionTimeout = setTimeout(onTransitionEnd, transitionDuration);
            }
        }
        previousPanel.current = isVisible;
        root.addEventListener('transitionend', onTransitionEnd);
        return function () { return root.removeEventListener('transitionend', onTransitionEnd); };
    }, [
        emitClose,
        emitCloseAnimationDone,
        emitOpen,
        emitOpenAnimationDone,
        isVisible,
        panelType,
        rootRef,
    ]);
    return { openAnimationEvent: openAnimationEvent, closeAnimationEvent: closeAnimationEvent, openEvent: openEvent, closeEvent: closeEvent };
}
//# sourceMappingURL=useCustomTransitionEvents.js.map